/* eslint-disable no-param-reassign, no-return-assign */

/* Play / Pause video */
document.querySelectorAll('.block-video').forEach((block, index) => {
    const videoContainer = block;
    const videoEl = videoContainer.querySelector('video');
    const playBtn = videoContainer.querySelector('.btn-play');

    if (videoEl && playBtn) {
        if (!videoEl.id) {
            videoEl.id = `video-${index}`;
        }

        playBtn.setAttribute('aria-controls', videoEl.id);
        playBtn.setAttribute('aria-pressed', 'false');

        playBtn.addEventListener('click', () => {
            videoEl.controls = true;
            videoEl.play();
            playBtn.setAttribute('aria-pressed', 'true');
            playBtn.setAttribute('aria-hidden', 'true');
            playBtn.style.visibility = 'hidden';
        });

        const showPlayBtn = () => {
            videoEl.controls = false;
            playBtn.setAttribute('aria-pressed', 'false');
            playBtn.setAttribute('aria-hidden', 'false');
            playBtn.style.visibility = '';
        };

        videoEl.addEventListener('pause', showPlayBtn);
        videoEl.addEventListener('ended', showPlayBtn);
    }
});

// Share buttons for an article
const shareUrl = window.location.href;
const encoded = encodeURIComponent(shareUrl);

const shareConfigs = [
    ['.btn-facebook-share', `https://www.facebook.com/sharer/sharer.php?u=${encoded}`],
    ['.btn-x-share', `https://twitter.com/intent/tweet?url=${encoded}`],
    ['.btn-mail-share', `mailto:?subject=&body=${encoded}`],
];

shareConfigs.forEach(([selector, url]) => {
    document.querySelectorAll(selector).forEach((btn) => btn.href = url);
});
